export default (isEditableTable, isEditableColumn) => isEditableColumn === undefined ?
    isEditableTable :
    isEditableColumn;
